import { Todo } from "../../types/Todo";
import createTodoRef from "../../utils/createTodoRef";

export default function createTodoData(firebase, data) {
	const ref = createTodoRef(firebase.firestore(), data.subjectRef.id, data.type);

	return Todo.parse({
		id: ref.id,
		ref,
		createdAt: firebase.firestore.FieldValue.serverTimestamp(),
		...data,
	});
}
